import { Link } from 'react-router-dom';
import { Facebook, Instagram, AtSign, Youtube, Music2, Settings2 } from 'lucide-react';
import { SOCIAL_PLATFORMS, type SocialPlatform } from '@unitly/contracts';
import { useWorkspaceChannels } from '../../api/queries.ts';
import { useOrgCtx } from '../../app/org-context.tsx';

const PLATFORM_LABEL: Record<SocialPlatform, string> = {
  facebook: 'Facebook', instagram: 'Instagram', threads: 'Threads', youtube: 'YouTube', tiktok: 'TikTok',
};
const PLATFORM_ICON: Record<SocialPlatform, typeof Facebook> = {
  facebook: Facebook, instagram: Instagram, threads: AtSign, youtube: Youtube, tiktok: Music2,
};

/** Read-only: which company account (connected and assigned from Settings → Integrazioni) this
 * workspace's Contenuti/Insights/Marketing tabs currently use, per platform. */
export function WorkspaceChannelsPanel({ workspaceId, canManage }: { workspaceId: string; canManage: boolean }) {
  const { base, orgId } = useOrgCtx();
  const channels = useWorkspaceChannels(orgId, workspaceId);

  if (!channels.data) return null;
  const relevant = SOCIAL_PLATFORMS.map((p) => channels.data!.find((c) => c.platform === p)).filter((c) => c?.assignment);

  return (
    <div className="card card-pad ws-channels" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontWeight: 600, flex: 1, minWidth: 0 }}>Account collegati a questo spazio</span>
        {canManage && (
          <Link to={`${base}/settings/integrations`} className="btn btn-plain btn-sm" style={{ padding: 0, height: 'auto', flex: 'none' }} aria-label="Gestisci gli account in Impostazioni → Integrazioni">
            <Settings2 size={14} /> Gestisci
          </Link>
        )}
      </div>
      {relevant.length === 0 ? (
        <p className="hint" style={{ padding: 0 }}>
          Nessun account assegnato a questo spazio. {canManage ? <>Vai su <Link to={`${base}/settings/integrations`}>Impostazioni → Integrazioni</Link> per collegarne uno.</> : 'Chiedi a un Owner o Admin di collegarne uno da Impostazioni → Integrazioni.'}
        </p>
      ) : (
        <div className="ws-channels-list">
          {relevant.map((c) => {
            const Icon = PLATFORM_ICON[c!.platform];
            return (
              <div key={c!.platform} className="ws-channel">
                <Icon size={16} style={{ opacity: 0.7, flex: 'none' }} />
                <span className="ws-channel-platform">{PLATFORM_LABEL[c!.platform]}</span>
                <span style={{ fontWeight: 500 }}>{c!.assignment!.pageName}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
